import type {
  PuppyBinaryExportResult,
  StepExportResult,
} from '@puppycad/cad-core'

/**
 * 下载 cad-core 生成的二进制导出结果。
 *
 * 设计说明：
 * 1. STEP、标准 GLB 与 Inspector 调试 GLB 共用相同浏览器下载生命周期；
 * 2. Object URL 必须在触发下载后立即释放，避免连续调试导出积累浏览器内存；
 * 3. 该工具只负责下载传输，不解释具体 CAD 导出格式。
 *
 * @param result cad-core 生成的二进制文件结果。
 */
export function downloadBinaryExportResult(
  result: StepExportResult | PuppyBinaryExportResult,
): void {
  const bytes = new Uint8Array(result.bytes)
  const blob = new Blob([bytes], { type: result.mimeType })
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  try {
    anchor.href = objectUrl
    anchor.download = result.fileName
    anchor.click()
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
